import type { FaireProductEntity } from "../../entity_types/product";

export const p_k0h831m: FaireProductEntity = {
  token: "p_k0h831m",
  type: "product",
  name: "Cold Pressed Green Juice",
  brandName: "Juice Lab NYC",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/83225eb332fd099df4377b239ff2c7695db66ef76052ebe99c9a7fca7b390396.webp",
  priceDollars: 8.5,
  description: "Fresh cold-pressed green juice from Manhattan",
  categoryTokens: ["cat_food-beverages"],
  tags: ["nyc-local", "premium", "organic"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/83225eb332fd099df4377b239ff2c7695db66ef76052ebe99c9a7fca7b390396.webp",
  weight: 1.1,
  dimensions: {
    width: 3,
    height: 9,
    depth: 3,
  },
  inStock: true,
};
